import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

export const success = (msg) => toast.success(msg,{
    autoClose:1500
});

export const error = (msg) => toast.error(msg,{
    autoClose:1500
});